import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_rc-notification@3.0.0@rc-notification/es/index.js
// module id = 253
// module chunks = 0